import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import { CookiesProvider } from 'react-cookie';
import theme from 'common/theme';
import App from './App';
import * as serviceWorker from './serviceWorker';

import 'typeface-roboto';

ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <CookiesProvider>
        <CssBaseline />
        <App />
      </CookiesProvider>
    </ThemeProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
